import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

export const ActivityIdleTimerComponent = ({ isConsultation }) => {
  const [timeoutDuration] = useState(1000 * 60 * 30);
  const [debounceDuration] = useState(750);
  const [openPopup, setOpenPopup] = useState(false);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const idleTimer = useRef();

  const onAction = () => {
    setIsTimedOut(false);
  };

  const onActive = (event) => {
    setIsTimedOut(false);
  };

  const onIdle = (event) => {
    if (!isTimedOut && isConsultation) {
      setOpenPopup(true);
      idleTimer.current.reset();
      setIsTimedOut(true);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <IdleTimer
        ref={idleTimer}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        onAction={onAction}
        debounce={debounceDuration}
        timeout={timeoutDuration}
      />

      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={openPopup}
        onClose={handleClosePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            borderRadius: "5px",
            width: "400px",
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{ textAlign: "center", fontWeight: "400", fontSize: "15px" }}
          >
             {t("Home.ActivityIdlePopup.GoRefreshMessage")}
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ActivityIdleTimerComponent.js